"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_actions_enum_1 = require("../constants/api-actions.enum");
const serialization_1 = require("../utils/serialization");
function serializeParameters(parameters) {
    return Promise.all(parameters.map((parameter) => __awaiter(this, void 0, void 0, function* () {
        if ((0, serialization_1.isUint8Array)(parameter)) {
            return yield (0, serialization_1.uint8ArrayToSerializedParameter)(parameter);
        }
        return parameter;
    })));
}
function deserializeResponse(response) {
    if ((0, serialization_1.isSerializedUint8Array)(response)) {
        return (0, serialization_1.base64ToUint8Array)(response.value);
    }
    return response;
}
function createProxy(path, messages) {
    return new Proxy({}, {
        get(target, property) {
            return (...parameters) => __awaiter(this, void 0, void 0, function* () {
                const response = yield messages.sendMessage(api_actions_enum_1.ApiActions.FDP_STORAGE, {
                    accessor: `${path}.${property}`,
                    parameters: yield serializeParameters(parameters),
                });
                return deserializeResponse(response);
            });
        },
    });
}
function createObjectProxy(path) {
    return new Proxy({}, {
        get() {
            return {};
        },
        set() {
            return true;
        },
    });
}
function createFdpStorageProxy(messages) {
    return {
        account: createProxy('account', messages),
        // TODO some of the types are not exported by fdp-storage, should be exported
        connection: createProxy('connection', messages),
        directory: createProxy('directory', messages),
        ens: createProxy('ens', messages),
        file: createProxy('file', messages),
        personalStorage: createProxy('personalStorage', messages),
        cache: createObjectProxy('cache'),
    };
}
exports.default = createFdpStorageProxy;
